<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SelectMultipleCounter
          filter="domain"
          :items="store.filters.domain"
          :active-filters="selectedFilters.domain"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          Sources
        </SelectMultipleCounter>
      </FiltersMenu>
    </div>

    <div class="params-row">
      <TotalMatched :item-count="store.item_count" />
      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Communiqués par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import { useNewsStore } from "@follaw-fr/stores/news";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const store = useNewsStore();

const { selectedFilters } = storeToRefs(store);

const fetchNews = async () => {
  selectedFilters.value.from = 0;
  await store.fetchNewsList();
};

const activeFilters = computed(() => {
  let arr = [];
  // Repeat for each filtering property (ex : domain, status, etc.)
  selectedFilters.value?.domain?.forEach((filter) => {
    arr = [...arr, { filter: "domain", item: filter }];
  });
  return arr;
});

const showScrollTop = computed(() => selectedFilters.value.size > 20);

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      fetchNews();
    },
  });

const addFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];
  targetFilters = [...targetFilters, event.item];

  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: targetFilters,
  };

  fetchNews();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] ?? [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }

  fetchNews();
};
const resetFilter = (event) => {
  delete selectedFilters.value[event];
  fetchNews();
};

const resetAllFilters = () => {
  store.resetFilters();
  fetchNews();
};
</script>
